import { store } from '@/store/store';
import { datos_adicionales_producto } from '@/shared/dtos/datos_adicionales_producto';
import {
    VuexModule,
    Mutation,
    getModule,
    Module,
    Action
} from 'vuex-module-decorators';
import { ssmHttpService } from '@/shared/services/http-service';
import { API } from '@/shared/api';

@Module({
    namespaced: true,
    name: 'datos_adicionales_productoModule',
    store,
    dynamic: true
})
class datos_adicionales_productoModule extends VuexModule {
    public datos_adicionales_productos: datos_adicionales_producto[] = [];
    public datos_adicionales_producto: datos_adicionales_producto = new datos_adicionales_producto();

    @Action({ commit: 'onGetdatos_adicionales_productos' })
    public async getdatos_adicionales_productos() {
        return await ssmHttpService.get(API.datos_adicionales_producto);
    }

    @Action({ commit: 'onGetdatos_adicionales_producto' })
    public async getdatos_adicionales_producto(id: any) {
        return await ssmHttpService.get(API.datos_adicionales_producto + '/' + id);
    }
    @Action({ commit: 'onGetdatos_adicionales_producto' })
    public async getdatos_adicionales_productoById(id: any) {
        return await ssmHttpService.get(API.datos_adicionales_producto + '/producto/' + id);
    }
    @Action({ commit: 'onGetdatos_adicionales_producto' })
    public async getdatos_adicionales_productoByIdDevoluciones(id: any) {
        return await ssmHttpService.get(API.datos_adicionales_producto + '/devolucionesproducto/' + id);
    }
    @Action
    public async guardardatos_adicionales_producto(datos_adicionales_producto: datos_adicionales_producto) {
        return await ssmHttpService.post(API.datos_adicionales_producto, datos_adicionales_producto.toJson());
    }

    @Action
    public async modificardatos_adicionales_producto(datos_adicionales_producto: datos_adicionales_producto) {
        return await ssmHttpService.put(API.datos_adicionales_producto + '/' + datos_adicionales_producto.id, datos_adicionales_producto);
    }

    @Action
    public async eliminardatos_adicionales_producto(datos_adicionales_producto: datos_adicionales_producto) {
        return await ssmHttpService.delete(API.datos_adicionales_producto + '/' + datos_adicionales_producto.id, null, false);
    }

    @Mutation
    public onGetdatos_adicionales_productos(res: datos_adicionales_producto[]) {
        this.datos_adicionales_productos = res ? res.map((x) => new datos_adicionales_producto(x)) : []
    }

    @Mutation
    public onGetdatos_adicionales_producto(res: datos_adicionales_producto) {
        this.datos_adicionales_producto = new datos_adicionales_producto(res);
    }

}
export default getModule(datos_adicionales_productoModule);